import { render, staticRenderFns } from "./AlibeyBills.vue?vue&type=template&id=2522efcf&scoped=true"
import script from "./AlibeyBills.vue?vue&type=script&lang=js"
export * from "./AlibeyBills.vue?vue&type=script&lang=js"
import style0 from "./AlibeyBills.vue?vue&type=style&index=0&id=2522efcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522efcf",
  null
  
)

export default component.exports